import React, { useEffect } from 'react'
import {connect} from 'react-redux'
import cn from 'classnames'
import toggleOpen from "../../decorators/toggleOpen"
import Rotate from '../common/Rotate'
import {checkAndUploadGeneralStatistic, generalStatisticForRenderSelector, checkedCategoriesStatisticForRenderSelector} from '../../modules/questions'


let Statistic = props => {
    let {isOpen, toggleOpen, checkAndUploadGeneralStatistic, generalStatistic, checkedCategoriesStatistic} = props
    let statistic = isOpen ? checkedCategoriesStatistic : generalStatistic;
    useEffect(() => {
        toggleOpen();
    }, [])
    return (
        <React.Fragment>
            <div className="flex flex-align-center flex-between w100">
                <div className="flex flex-center" onClick={toggleOpen} >
                    <span className="text-main dib pointer" style={{margin: "0 5px 0 0"}}>B</span>
                    <div className={cn("react-toggle react-toggle--color-on", {"react-toggle--checked" : isOpen})}>
                        <div className="react-toggle-track">
                            <div className="react-toggle-track-check"></div>
                            <div className="react-toggle-track-x"></div>
                        </div>
                        <div className="react-toggle-thumb"></div>
                        <input className="react-toggle-screenreader-only" type="checkbox" id="react-toggle-statistic" />
                    </div>
                    <span className="text-main dib pointer" style={{margin: "0 0 0 5px"}}>C</span>
                </div>
                <div className="flex ml-auto flex-center">
                    {
                        //!isOpen && <Rotate onClick = {() => checkAndUploadGeneralStatistic(true)} />
                    }
                    {
                        statistic.map(item => (
                            <div key={item.status} className={cn([
                                "qbm-accordion-content__num_icon",
                                "mx-1",
                                `qbm-accordion-content__num_${item.iconSuffix}`
                            ])}>{item.count}</div>
                        ))
                    }
                </div>
            </div>
        </React.Fragment>
    )
}

export default connect(
    state => ({
        generalStatistic : generalStatisticForRenderSelector(state),
        checkedCategoriesStatistic : checkedCategoriesStatisticForRenderSelector(state),
    }),
    {checkAndUploadGeneralStatistic}
)(
    toggleOpen(
        Statistic
    )
)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/Statistic.js